import {
  RaisedButton
} from 'material-ui'
import Helmet from 'react-helmet'
import { Enum } from 'utils'
import { Nav, SEOFixesCard, BlogFixesCard, SpeedFixesCard } from 'components'

import './getItFixed.scss'

export default class GetItFixed extends React.Component {
  render() {
    return (
      <div>
        <Helmet title='Plug in SEO - Get it Fixed' />
        <Nav 
          toolbarTitleText="Get it Fixed"
        />
        <div className='getitfixed'>
          <div className='getitfixed__headline-container'>
            <h2 className="headline medium-spacing--bottom">Get it Fixed</h2>
            <h3>Over 3000 Shopify Merchants have used our services to grow their business.</h3>
          </div>
          <div className='getitfixed__body'>
            <div className='getitfixed__body__callout'>
              <h2>Get help from our handpicked Shopify experts today. No contracts.</h2>
              <ul className='icon-font-list large-spacing--top'>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>Fixed price packages with no risk of being charged more</li>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>All experts are specifically experienced with Shopify</li>
                <li className='icon-font-list__list-item icon-font-list__list-item--check'>The smart and proven way to optimize & grow your store</li>
              </ul>
              <h2 className="xxlarge-spacing--top large-spacing2--bottom">Fix SEO problems, speed up your shop, write your blog</h2>
            </div>
            <div className='getitfixed__body__column'>
              <SEOFixesCard source={Enum.BlimponLinkLocations.getItFixedPage} />
            </div>
            <div className='getitfixed__body__column'>
              <SpeedFixesCard source={Enum.BlimponLinkLocations.getItFixedPage} />
            </div>
            <div className='getitfixed__body__column'>
              <BlogFixesCard source={Enum.BlimponLinkLocations.getItFixedPage} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/getitfixed/GetItFixed.js